import { defineStore } from 'pinia'
import type { ApiMode } from '../services/api'

/**
 * Mode courant du portail (TEST = sandbox pprod, LIVE = production).
 * Persisté en localStorage pour survivre à un rechargement.
 */
export const useModeStore = defineStore('mode', {
  state: () => ({
    mode: (localStorage.getItem('partnerPortalMode') as ApiMode) || 'TEST',
  }),

  getters: {
    isTest: (state) => state.mode === 'TEST',
    isLive: (state) => state.mode === 'LIVE',
    label: (state) => (state.mode === 'TEST' ? 'Test (sandbox)' : 'Production'),
  },

  actions: {
    setMode(mode: ApiMode) {
      this.mode = mode
      localStorage.setItem('partnerPortalMode', mode)
    },

    toggle() {
      this.setMode(this.mode === 'TEST' ? 'LIVE' : 'TEST')
    },
  },
})
